<div class="fixed top-6 right-6 z-[99999] flex flex-col gap-3 items-end pointer-events-none">

  <ng-container *ngFor="let t of toasts">
    <div
      class="pointer-events-auto max-w-sm w-full rounded-xl shadow-xl border bg-white dark:bg-slate-800 p-4 flex items-start gap-3 animate-slide-up"
      [ngClass]="{
        'border-l-4 border-emerald-500': t.type === 'success',
        'border-l-4 border-rose-500': t.type === 'error',
        'border-l-4 border-sky-500': t.type === 'info',
        'border-l-4 border-amber-400': t.type === 'warning'
      }"
    >
      <div
        class="flex-shrink-0 h-8 w-8 rounded-full flex items-center justify-center"
        [ngClass]="{
          'bg-emerald-100 text-emerald-600': t.type === 'success',
          'bg-rose-100 text-rose-600': t.type === 'error',
          'bg-sky-100 text-sky-600': t.type === 'info',
          'bg-amber-100 text-amber-600': t.type === 'warning'
        }"
      >
        <ng-container [ngSwitch]="t.type">
          <svg *ngSwitchCase="'success'" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0L6.293 11.707a1 1 0 011.414-1.414L9 11.586l3.293-3.293a1 1 0 011.414 0z" clip-rule="evenodd" /></svg>
          <svg *ngSwitchCase="'error'" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm-1-8V6a1 1 0 112 0v4a1 1 0 11-2 0zm0 4a1 1 0 112 0 1 1 0 11-2 0z" clip-rule="evenodd" /></svg>
          <svg *ngSwitchCase="'info'" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="currentColor" viewBox="0 0 20 20"><path d="M9 9h2v6H9V9zm1-6a1 1 0 100 2 1 1 0 000-2z"/></svg>
          <svg *ngSwitchCase="'warning'" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="currentColor" viewBox="0 0 20 20"><path d="M8.257 3.099c.765-1.36 2.72-1.36 3.486 0l6.518 11.596A1.75 1.75 0 0116.52 18H3.48c-.94 0-1.61-1.006-1.24-1.805L8.257 3.1zM11 13a1 1 0 10-2 0 1 1 0 002 0zm-1-6a.75.75 0 00-.75.75v3.5c0 .414.336.75.75.75s.75-.336.75-.75v-3.5A.75.75 0 0010 7z"/></svg>
        </ng-container>
      </div>

      <div class="flex-1">
        <div *ngIf="t.title" class="text-sm font-semibold">{{ t.title }}</div>
        <div class="text-sm text-slate-600 dark:text-slate-300 mt-0.5">
          {{ t.message }}
        </div>
      </div>

      <button (click)="remove(t.id)" class="ml-3 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200">✕</button>
    </div>
  </ng-container>
</div>
